<template>
  <el-dialog
    title="选择课程"
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="handleClose"
  >
    <el-row>
      <el-col :span="8">
        <el-input
          size="small"
          v-model="courseName"
          placeholder="-课程名称-"
        ></el-input>
      </el-col>
      <el-col :span="2">
        <el-button size="small" type="primary" @click="getCourseList"
          >搜索</el-button
        >
      </el-col>
      <el-col
        :span="4"
        :push="8"
        style="font-size: 16px; color: #000; margin-top: 10px"
      >
        绑定下列课程
      </el-col>
    </el-row>
    <div class="double_table">
      <div class="left">
        <el-table
          :data="tableData"
          height="400"
          style="width: 100%"
          :header-cell-style="{ 'background-color': '#f2f2f2' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            prop="video_title"
            label="课程名称"
          ></el-table-column>
          <el-table-column
            prop="course_code"
            label="课程代码"
          ></el-table-column>
          <el-table-column
            prop="video_type_title"
            label="课程性质"
          ></el-table-column>
          <el-table-column prop="title" label="学校机构"></el-table-column>
          <el-table-column prop="name" label="课程讲师"> </el-table-column>
        </el-table>
      </div>
      <div class="middle">
        <div class="go" @click="turnRight">
          <i class="el-icon-arrow-right"></i>
        </div>
        <div class="back" @click="turnLeft">
          <i class="el-icon-arrow-left"></i>
        </div>
      </div>
      <div class="right">
        <el-table
          :data="choseTableData"
          style="width: 100%"
          height="400"
          :header-cell-style="{ 'background-color': '#f2f2f2' }"
          @selection-change="handleChoseSelectionChange"
        >
          <el-table-column
            type="selection"
            :selectable="selecTable"
            width="55"
          ></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="55"
          ></el-table-column>
          <el-table-column
            prop="video_title"
            label="课程名称"
          ></el-table-column>
          <el-table-column
            prop="course_code"
            label="课程代码"
          ></el-table-column>
          <el-table-column
            prop="video_type_title"
            label="课程性质"
          ></el-table-column>
          <el-table-column prop="title" label="学校机构"></el-table-column>
          <el-table-column prop="name" label="课程讲师"> </el-table-column>
        </el-table>
      </div>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
      style="display: flex; justify-content: center"
    >
      <el-button type="primary" @click="submit">确定</el-button>
      <el-button type="info" @click="handleClose">返回</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as api from '@/api/ClassManagement/chooseCourse.js'
export default {
  // props: ['choseData'],
  props: {
    albumId: {
      type: Number,
      default: () => 0,
    },
    choseData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: true,
      tableData: [],
      selectedList: [],
      choseTableData: [],
      choseSelectedList: [],
      courseName: '',
      // num: 0,
    }
  },
  created() {
    // this.getCourseList()
  },
  methods: {
    async getCourseList() {
      // this.num++
      let params = { courseName: this.courseName }
      if (this.albumId)
        params = Object.assign(params, { albumId: this.albumId })
      const { code, data } = (await api.getCourseList(params)).data
      if (code === 100000) {
        let tableData = []
        let choseTableData = []
        data.forEach((item) => {
          if (item.checked) {
            choseTableData.push(item)
          } else {
            tableData.push(item)
          }
        })
        if (this.choseData && this.choseData.length) {
          let arr = []
          this.choseData.forEach((item) => {
            arr.push(item.id)
          })
          tableData = tableData.filter((item) => !arr.includes(item.id))
          choseTableData = choseTableData.filter(
            (item) => !arr.includes(item.id)
          )
        }
        this.tableData = tableData
        this.choseTableData = [...choseTableData, ...this.choseData]
      }
    },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
    },
    // 处理选中事件
    handleChoseSelectionChange(arr) {
      this.choseSelectedList = arr
    },
    turnRight() {
      this.choseTableData = [...this.choseTableData, ...this.selectedList].sort(
        (a, b) => a.id - b.id
      )
      let arr = []
      this.selectedList.forEach((item) => {
        arr.push(item.id)
      })
      this.tableData = this.tableData.filter((item) => !arr.includes(item.id))
    },
    turnLeft() {
      this.tableData = [...this.tableData, ...this.choseSelectedList].sort(
        (a, b) => a.id - b.id
      )
      let arr = []
      this.choseSelectedList.forEach((item) => {
        arr.push(item.id)
      })
      this.choseTableData = this.choseTableData.filter(
        (item) => !arr.includes(item.id)
      )
    },
    handleClose() {
      this.$emit('closeChooseCourse')
    },
    submit() {
      console.log('this.choseTableData', this.choseTableData)
      this.$emit('closeChooseCourse', this.choseTableData)
    },
    selecTable(row, index) {
      return row.checked
    },
    handleDialog() {
      this.getCourseList()
    },
  },
  watch: {
    dialogVisible: {
      immediate: true,
      handler: function (newValue) {
        console.log('dialogVisible', newValue)
        if (newValue) this.handleDialog()
      },
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog {
  .el-dialog__header {
    background-color: #f2f2f2;
  }
}
/deep/.el-table__header {
  .gutter {
    background-color: #f2f2f2;
  }
}
.el-row {
  font-size: 14px;
}
.double_table {
  display: flex;
  .left,
  .right {
    width: 46%;
  }
  .middle {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .go {
      margin-bottom: 54px;
    }
    .go,
    .back {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 26px;
      color: #000;
      background-color: #d7d7d7;
      border-radius: 6px;
      cursor: pointer;
    }
    .el-icon-arrow-left,
    .el-icon-arrow-right {
      font-weight: 700;
    }
  }
}
</style>